import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { ShieldAlert } from "lucide-react";
import { supabase } from "@/integrations/supabase/client";

export function SuspendedAccountScreen() {
  const handleSignOut = async () => {
    try {
      localStorage.removeItem('selectedTenantId');
      localStorage.removeItem('selectedTenantSlug');
      await supabase.auth.signOut();
    } finally {
      window.location.href = '/auth';
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-6">
      <Card className="w-full max-w-md border-destructive">
        <CardHeader className="text-center">
          <div className="mx-auto w-12 h-12 rounded-lg bg-destructive/10 flex items-center justify-center text-destructive mb-4">
            <ShieldAlert className="h-6 w-6" />
          </div>
          <CardTitle className="text-2xl">Account Suspended</CardTitle>
          <CardDescription>
            Your account has been suspended in all organizations. Please contact your
            administrator to restore access.
          </CardDescription>
        </CardHeader>
        <CardContent className="flex justify-center">
          <Button variant="outline" onClick={handleSignOut}>Sign out</Button>
        </CardContent>
      </Card>
    </div>
  );
}
